import { render, staticRenderFns } from "./csok-calculator.vue?vue&type=template&id=8750e19c&scoped=true&lang=pug"
import script from "./csok-calculator.vue?vue&type=script&setup=true&lang=js"
export * from "./csok-calculator.vue?vue&type=script&setup=true&lang=js"
import style0 from "./csok-calculator.vue?vue&type=style&index=0&id=8750e19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8750e19c",
  null
  
)

export default component.exports